import React from 'react';
import PropTypes from 'prop-types';
import AutosizeInput from 'react-input-autosize';
import { inputStyle, AutosizeInputWrapper } from './styled';

const Input = (props) => (
  <AutosizeInputWrapper>
    <AutosizeInput
      {...props} 
      type='text'
      autoCorrect='off'
      spellCheck='false'
      autoComplete='off'
      autoCapitalize='none'
      aria-autocomplete='list' 
      inputStyle={inputStyle}
      data-test={`${props.dataTestId}-dropdown-input`}
    />
  </AutosizeInputWrapper>
);

Input.propTypes = {
  id: PropTypes.string,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  inputRef: PropTypes.oneOfType([
    PropTypes.func, 
    PropTypes.shape({ current: PropTypes.instanceOf(Element) })
  ]),
};

export default Input;